import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { memo } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { OrderProductError } from '../../../../../../services/modules/order-product/order-product.types';
import { useTranslation } from '../../../../../translation/TranslationContext';
import OrderValidationErrorsTooltipContent from '../../../../edit/validate/components/OrderValidationErrorsTooltipContent';
import { BusinessPolicyItemViolationView } from '../../../../edit/validate/conditions/businessPolicy/businessPolicyViolation.types';
import BusinessPolicyItemViolations from '../../../../edit/validate/conditions/businessPolicy/components/BusinessPolicyItemViolations';
import useOrderProductImageAndLabelTooltip from './hooks/useOrderProductImageAndLabelTooltip';

interface OrderProductImageAndLabelTooltipProps {
  productErrors?: OrderProductError[];
  productBusinessPolicyViolations?: BusinessPolicyItemViolationView[];
  onOpenDetails?: () => void;
}

const OrderProductImageAndLabelTooltip = ({
  productErrors = [],
  productBusinessPolicyViolations = [],
  onOpenDetails,
}: OrderProductImageAndLabelTooltipProps) => {
  const { translate } = useTranslation();
  const { registrationErrors } = useOrderProductImageAndLabelTooltip(productErrors);

  return (
    <Stack sx={{ gap: 1.5, maxWidth: 400 }}>
      {!!registrationErrors.length && (
        <OrderValidationErrorsTooltipContent errors={registrationErrors} />
      )}

      {!!productBusinessPolicyViolations.length && (
        <Stack sx={{ gap: 1 }}>
          <Typography variant="subtitle2" color="inherit">
            {translate(LangEnum.ORDER_VALIDATION_POLICY_PENDING)}
          </Typography>
          <BusinessPolicyItemViolations
            itemViolations={productBusinessPolicyViolations}
            onOpenDetails={onOpenDetails}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default memo(OrderProductImageAndLabelTooltip);
